var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-items"},_vm._l((_vm.items),function(item,index){return _c('a',{staticClass:"social-items__item",attrs:{"href":item.content}},[_c('img',{attrs:{"src":item.media,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }